import { useCallback } from "react";
import { useUserState } from "./useUserState";

/** Hours before the period within which an older value still counts as recent (yellow, not red). */
export const STALE_AFTER_HOURS_OPTIONS = [6, 12, 24, 48, 72] as const;

export type StaleAfterHours = (typeof STALE_AFTER_HOURS_OPTIONS)[number];

export const DEFAULT_STALE_AFTER_HOURS: StaleAfterHours = 24;

const DEFAULTS = { hours: DEFAULT_STALE_AFTER_HOURS as number };

/**
 * How far before the period a checklist value may lie and still be yellow rather than red,
 * remembered per user.
 */
export function useStaleAfterHours() {
  const { value, setValue } = useUserState("checklist:staleAfterHours", DEFAULTS);

  const hours =
    STALE_AFTER_HOURS_OPTIONS.find(option => option === value.hours) ?? DEFAULT_STALE_AFTER_HOURS;
  const setHours = useCallback((next: StaleAfterHours) => setValue({ hours: next }), [setValue]);

  return { hours, setHours };
}
